module.exports = __webpack_public_path__ + "d0273796097f34da52a030b1c8e66b72.svg";